module.exports = __webpack_public_path__ + "static/media/payment-icon-amex.8e08167f.svg";